import React from 'react';
import './static-loader.scss';

export default function StaticLoader(props) {
  return (
    <span className={`icon icon-loading ${props.className ? props.className : ''}`}>
      <span className="path1"></span>
      <span className="path2"></span>
      <span className="path3"></span>
    </span>
  );
}
